export class Result {
  status: boolean;
  message: string;
}
